module.exports = __webpack_public_path__ + "static/media/guandao_pic6.6d78a283.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/guandao_pic6.jpg
 ** module id = 442
 ** module chunks = 0
 **/